import React from 'react';
import { CharacterImageMap } from '../../../../../../enums/CharacterType';
import classes from './MonsterCell.module.css';

const MonsterCell = ({ value }) => {

  const monsterId = Number(value)
  if (!monsterId || monsterId < 1 || monsterId > 10) {
    return (
      <div className={classes.monsterCell}>
        <span>-</span>
      </div>
    );
  }

  const monsterImage = CharacterImageMap[monsterId];
  const imageSrc = monsterImage?.default || monsterImage;

  if (!imageSrc) {
    return (
      <div className={classes.monsterCell}>
        <span>-</span>
      </div>
    );
  }

  return (
    <div className={classes.monsterCell}>
      <img src={imageSrc} alt={`Character ${monsterId}`} className={classes.monsterImage} />
    </div>
  );
};

export default MonsterCell;
